<template>
  <div :class="field.class || 'col-md-3'" class="col" v-if="!field.hidden">
    <template v-if="field.type === 'input'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <b-form-input
          :type="field.typeInput || 'text'"
          :placeholder="field.placeholder"
          v-model="getFieldValue"
          debounce="300"
          @keydown="keyDown"
        />
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'range'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <b-form-input
          type="range"
          :min="field.min || '0'"
          :max="field.max || '5'"
          v-model="getFieldValue"
          debounce="300"
        />
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'range_slider'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <vue-range-slider
          :style='{"margin-top": "10px"}'
          :data="field.data || null"
          v-model="getFieldValue"
          :tooltip="false"
          :dot-size="12"
          :process-style='{ "background-color": "#007bff" }'
        ></vue-range-slider>
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'switch'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <b-button
          variant="secondary"
          class="button btn-icon button-checkbox_sm"
        >
          <b-form-checkbox
            size="sm"
            switch
            v-model="getFieldValue"
            class="switch"
          />
        </b-button>
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'checkbox'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <b-form-checkbox v-model="getFieldValue" />
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'multiselect'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <multiselect
          v-model="getFieldValue"
          :allow-empty="field.allowEmpty"
          :placeholder="field.placeholder"
          :tag-placeholder="field.placeholder"
          :options="field.options"
          :track-by="field.valueField"
          :label="field.selectLabel"
          :multiple="true"
          :showLabels="false"
        >
          <template slot="selection" slot-scope="{ values, isOpen }">
            <span class="multiselect__single" v-if="values.length && !isOpen">
              {{ values.length }}/{{ field.options.length }}
            </span>
          </template>
          <template slot="option" slot-scope="props" v-if-="field.labelClass && field.labelClass !== ''">
            <div class="option__desc">
               <span class="option__title" :class="field.labelClass">{{ field.selectLabel ? props.option[field.selectLabel] : props.option }}</span>
            </div>
          </template>
          <template slot="tag"
            ><i></i
          ></template>
        </multiselect>
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'select'">
      <b-form-group>
        <label class="form__label">{{ field.label }}</label>
        <multiselect
          v-model="getFieldValue"
          :options="field.options"
          :placeholder="field.placeholder"
          :track-by="field.valueField"
          :label="field.selectLabel"
          :disabled="field.disabled"
          :allow-empty="field.allowEmpty ? field.allowEmpty : false"
          :showLabels="false"
        >
          <template slot="option" slot-scope="props" v-if-="field.labelClass && field.labelClass !== ''">
            <div class="option__desc">
              <span class="option__title" :class="field.labelClass">{{ field.selectLabel ? props.option[field.selectLabel] : props.option }}</span>
            </div>
          </template>
        </multiselect>
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'datepicker'">
      <b-form-group style="position: relative;">
        <label class="form__label">{{ field.label }}</label>
        <!-- TODO NEED UPDATE VUE BOOTSTRAP AND REMOVE CURRENT DATAPICKER, INPUT -->
        <b-form-input
          style="position: absolute;height: 32px;"
          :value="convertDataToString(getFieldValue)"
        />
        <Datepicker
          :bootstrap-styling="true"
          :disabledDates="field.disabledDates"
          :placeholder="field.placeholder"
          :format="field.format"
          :minimum-view="field.minimumView"
          class="datapicker"
          :value="moment(getFieldValue).toISOString()"
          @input="getFieldValue = _toLocalTime($event)"
        />
        <slot name="errors"></slot>
      </b-form-group>
    </template>
    <template v-if="field.type === 'component'">
      <component
        v-model="getFieldValue"
        v-on="field.action"
        v-bind:is="field.component"
        v-bind="field"
      >
      </component>
    </template>
    <template v-if="field.type === 'slot'">
      <b-form-group>
        <slot :data="field" :fields="fields"></slot>
        <slot name="errors"></slot>
      </b-form-group>
    </template>
  </div>
</template>

<script>
import Moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import VueRangeSlider from 'vue-range-component-fixed'
import 'vue-range-component-fixed/dist/vue-range-slider.css'

export default {
  name: 'FormGeneratorItems',
  components: {
    Datepicker,
    VueRangeSlider
  },
  data () {
    return {
      fields: {}
    }
  },
  props: {
    field: {
      type: Object,
      default: () => {}
    },
    value: {}
  },
  computed: {
    getFieldValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
        this.$emit('update', this.$vnode.key, this.field)
      }
    },
    moment () {
      return Moment
    }
  },
  methods: {
    convertDataToString (value) {
      if (value) return value.toString()
    },
    keyDown (event) {
      this.$emit('keyDown', event)
    }
  }
}
</script>
